export default "__VITE_ASSET__9c590aef__"